export default event => {
  const key = event.key || event.keyCode;

  return key === 'Escape' || key === 'Esc' || key === 27;
};
